export default __webpack_public_path__ + "static/media/green-check.6f97b9e2.svg";